import { render, staticRenderFns } from "./SideModal.vue?vue&type=template&id=86349f1e"
import script from "./SideModal.vue?vue&type=script&lang=js"
export * from "./SideModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports